<template>
  <modalEquipaments
    :equipmentsDTO="equipmentsWatchList"
    :details="item"
  ></modalEquipaments>

  <!-- <div div id="details" class="wrapper-group-itens b-container">
        <div class="row d-flex justify-content-between content">
          {{ equipmentsWatchList }}
          <div  v-for="(itemEquipment, index)  in equipmentsDTO" :key="index" class="selected">
            <h5> {{ itemEquipment.title }}</h5>
            <div class="selected-box">
              <div v-if="!details[itemEquipment.key].length">
             {{ `${itemEquipment.noDataMessage}  ${details.NAME}.`}}
              </div>
              <div
                class="selected-item"
                v-for="subItemEquip in details[itemEquipment.key]"
                :key="subItemEquip.ID"
              > 
              {{ subItemEquip.NAME }}
              </div> 
            </div>
          </div>
          <div class="selected">
            <h5>Agendas</h5>
            <div class="selected-box">
              <div v-if="!details.AGN.length">
                Não há agendas cadastradas no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="agn in details.AGN"
                :key="agn.ID"
              > 
              {{ agn.NAME }}
              </div> 
            </div>

          </div>
          <div class="selected">
            <h5>Bombas</h5>
            <div class="selected-box">
              <div v-if="!details.PUMP.length">
                Não há bombas cadastradas no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="pump in details.PUMP"
                :key="pump.ID"
              >
                {{ pump.NAME }}
              </div>
            </div>
          </div>
          <div class="selected">
            <h5>Válvulas</h5>
            <div class="selected-box">
              <div v-if="!details.VALVE.length">
                Não há válvulas cadastradas no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="valve in details.VALVE"
                :key="valve.ID"
              >
                {{ valve.NAME }}
              </div>
            </div>
          </div>
          <div class="selected">
            <h5>Hidrômetros</h5>
            <div class="selected-box">
              <div v-if="!details.HYDRO.length">
                Não há hidrômetros cadastrados no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="hydro in details.HYDRO"
                :key="hydro.ID"
              >
                {{ hydro.NAME }}
              </div>
            </div>
          </div>
          <div class="selected">
            <h5>Sensores</h5>
            <div class="selected-box">
              <div v-if="!details.SENSOR.length">
                Não há sensores cadastrados no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="sensor in details.SENSOR"
                :key="sensor.ID"
              >
                {{ sensor.NAME }}
              </div>
            </div>
          </div>
          <div class="selected">
            <h5>Usuários</h5>
            <div class="selected-box">
              <div v-if="!details.USERS.length">
                Não há usuários cadastrados no setor {{ details.NAME }}.
              </div>
              <div
                class="selected-item"
                v-for="user in details.USERS"
                :key="user.ID"
              >
                {{ user.NAME }}
              </div>
            </div>
          </div> 
          
        </div>
      </div> -->
</template>

<script>
import { users, listEquipments } from "@/api";
import { user } from "@/pages/components/globalstore";
import modalEquipaments from "@/common/components/modalEquipaments.vue";
export default {
  async created() {
    await this.loadUsers();
    await this.LoadData();
    await this.loadEquipments();
    // this.openGroupElements()
  },
  components: {
    modalEquipaments,
  },
  props: {
    itemSelected: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.item.PUMP;
  },
  data() {
    return {
      showForm: false,
      showElements: false,
      //view
      isGroup: null,
      groups: [],
      loading: true,
      list: [],
      fullList: [],
      isSearching: false,
      filter: "",
      selected: [],
      allSelected: false,
      //edição ou adição de agenda
      formType: "add",
      fields: [
        {
          key: "CHECK",
        },
        {
          key: "NAME",
        },
      ],
      equipmentsDTO: [
        {
          key: "USERS",
          title: "Usuários",
          noDataMessage: "Não há usuários cadastrados no setor",
        },
        {
          key: "AGN",
          title: "Agendas",
          noDataMessage: "Não há agendas cadastradas no grupo",
        },
        {
          key: "HYDRO",
          title: "Hidrômetros",
          noDataMessage: "Não há hidrômetros cadastrados no grupo",
        },
        {
          key: "PUMP",
          title: "Bombas",
          noDataMessage: "Não há bombas cadastradas no grupo",
        },
        {
          key: "SENSOR",
          title: "Sensores",
          noDataMessage: "Não há sensores cadastrados no grupo",
        },
        {
          key: "VALVE",
          title: "Válvulas",
          noDataMessage: "Não há válvulas cadastrados no grupo",
        },
        // "VALVE",
      ],
      detailsTab: 0,
      showErrorNotFound: false,
      showErrorNotSearch: false,
    };
  },
  computed: {
    item() {
      return this.itemSelected;
    },
    equipmentsWatchList() {
      return this.equipmentsDTO.map((itemEquipment) => {
        itemEquipment.list = this.item[itemEquipment.key];
        return itemEquipment;
      });
    },
  },
};
</script>

<style scoped>
.wrapper-group-itens {
  position: inherit !important;
  box-shadow: none !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

.wrapper-group-itens > .content {
  margin: auto;
  width: 60% !important;
}
.selected {
  width: 100% !important;
}
</style>
